import React from 'react';

// §7.2.2 — card: title, divider, body, Read more link, image at bottom.
export default function StructuralCard({ card }) {
  const href = card.readMoreHref || '#';
  const external = /^https?:\/\//i.test(href);
  return (
    <article className="scard">
      <h3 className="scard__title">{card.title}</h3>
      <span className="scard__rule" aria-hidden="true" />
      <p className="scard__body">{card.body}</p>
      <a
        className="scard__more"
        href={href}
        target={external ? '_blank' : undefined}
        rel={external ? 'noopener noreferrer' : undefined}
      >
        {card.readMoreLabel || 'Read more'}
      </a>
      <img className="scard__img" src={card.image} alt={card.title} loading="lazy" />
    </article>
  );
}
